<template>
    <div class="lms__user_account_learninghistory">
        <component-list
            ref="componentlist"
            :component-table="LmsSuperadminUsersProfileEditLearningHistoryTable"
            :component-table-name="'learning-history'"
            :filter-search-queryable="true"
            :get-pagination-getter="'getEbsEnrolmentsCustomAnyPagination'"
            :get-items-getter="'getEbsEnrolmentsCustomAnyData'"
            :get-items-dispatch="'ebsEnrolmentsGetAny'"
            :item-name="['enrolment', 'enrolments']"
            :default-page-size="24"
            :table-preferences-active="true"
        >
        </component-list>
        <component-title
            :class="'lms__user_account_learninghistory_externaltitle'"
            :size="'large'"
            :raw="true"
        >External learning history</component-title>
        <component-list
            ref="componentlistexternal"
            :component-table="LmsSuperadminUsersProfileEditLearningHistoryExternalTable"
            :component-table-name="'learning-history-external'"
            :filter-search-queryable="true"
            :get-pagination-getter="'getEbsEnrolmentsCustomExternalPagination'"
            :get-items-getter="'getEbsEnrolmentsCustomExternalData'"
            :get-items-dispatch="'ebsEnrolmentsGetExternal'"
            :get-items-dispatch-data="userId"
            :item-name="['enrolment', 'enrolments']"
            :table-preferences-active="true"
        ></component-list>
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminUsersProfileEditLearningHistoryTable from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditLearningHistoryTable'
import LmsSuperadminUsersProfileEditLearningHistoryExternalTable from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditLearningHistoryExternalTable'
import ComponentTitle from '@/components/default/shared/ComponentTitle'

export default {
  name: 'lms-user-account-learning-history',
  data () {
    return {
      LmsSuperadminUsersProfileEditLearningHistoryTable,
      LmsSuperadminUsersProfileEditLearningHistoryExternalTable
    }
  },
  computed: {
    userId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataUserId
    }
  },
  components: { ComponentTitle, ComponentList }
}
</script>
